<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>

      <text-input-group v-model="title" label="Title"></text-input-group>

      <text-input-group v-model="subtitle" label="Subtitle"></text-input-group>

      <div class="form-group form-row">
        <label :for="safeId('gang')" class="col-sm-4 col-form-label">Gang</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('gang')" v-model="gang" :options="gangOptions"
                         text-field="label" value-field="value">
          </b-form-select>
        </div>
      </div>

      <table-edit :cols="columnDefinitions" :rows="records"></table-edit>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row" v-for="(v, k) in columnDefinitions" :key="k">
        <label :for="safeId(k)" class="col-sm-4 col-form-label">{{ v }}</label>
        <div class="col-sm-8">
          <column-select :id="safeId(k)" :value="columnMap[k]" @input="val => {
            columnMap[k] = val
            columnMap = columnMap
          }" :dataset-id="datasetId"></column-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <number-input-group v-model="pageIntervalSecs" label="Page interval (s)"/>
        <number-input-group v-model="itemsPerPage" label="Items per page"/>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapOverlayOptions, mapTemplateData } from '@/utils'
  import * as action from '@/store/action-types'
  import * as mutation from '../../store/mutation-types'

  export default {
    name: 'swiss-wrestling-matches',
    mixins: [templateMixin],
    data () {
      return {
        gangOptions: new Array(6).fill(null).map((v, i) => ({label: `${i + 1}. Gang`, value: i + 1})),
        columnDefinitions: {
          'nachname1': 'Nachname 1',
          'vorname1': 'Vorname 1',
          'sterne1': 'Sterne 1',
          'verband1': 'Verband 1',
          'nachname2': 'Nachname 2',
          'vorname2': 'Vorname 2',
          'sterne2': 'Sterne 2',
          'verband2': 'Verband 2'
        }
      }
    },
    computed: {
      ...mapOverlayData(['title', 'subtitle']),
      ...mapOverlayData({'records': {default: []}}),
      ...mapOverlayOptions({pageIntervalSecs: {default: 0}, itemsPerPage: {default: 6}}),
      ...mapTemplateData(['datasetId', 'gang']),
      ...mapTemplateData({columnMap: {default: {}}}),
      records () {
        const dataset = this.$store.getters.dataset(this.datasetId)
        if (!dataset) return []
        const records = [].concat(dataset.records)
        records.sort((a, b) => {
          return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER)
        })
        return records.map(record => {
          return this.mapRecord(record, this.columnMap)
        })
      }
    },
    watch: {
      gang: function (val) {
        const dataset = this.$store.getters.dataset(this.datasetId)
        if (!dataset || !dataset.fileName) return

        let fileName = dataset.fileName
        const queryStringIndex = fileName.indexOf('?')

        if (queryStringIndex !== -1) {
          const baseUrl = fileName.substring(0, queryStringIndex) // Extract base URL
          const queryString = fileName.substring(queryStringIndex) // Extract query string

          // Use regex to find and replace attributes.gang with the new value
          const updatedQueryString = queryString.replace(/(attributes\.gang=)\d+/, `$1${val}`)

          // Rebuild the fileName string with updated query parameters
          fileName = baseUrl + updatedQueryString

          // Check if fileName has changed
          if (fileName !== dataset.fileName) {
            // Commit the updated fileName to the store
            this.$store.commit(mutation.DATASET_UPDATE_META, {
              datasetId: dataset.datasetId,
              fileName: fileName,
              emit: true
            })
          }
        }
      },
      records: function (val) {
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {records: val}
        })
      }
    },
    methods: {
      mapRecord (record, columnMap) {
        const each = Object.keys(columnMap).reduce((result, key) => {
          result[key] = record[columnMap[key]]
          return result
        }, {})
        each.name = [each.nachname1, each.vorname1, each.sterne1, '-', each.nachname2, each.vorname2, each.sterne2].join(' ')
        return each
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/swiss-wrestling-matches.vue